<template>
  <div class="col-12 col-lg-8 g c">
    <div class="card">
        <div class="card-body">
            <h5>
                اعدادات الاداة المتطورة (الواتس المباشر)
            </h5>
            <hr>
            <div class="col-12 table-responsive" style="min-height: 0px">
                <table class="table table-bordered table-hover">
                    <tbody>
                        <tr>
                            <td>
                                موقع الواتس المباشر
                            </td>
                            <td>
                                <a href="https://wa.smart-whats.com" target="_blank">
                                    wa.smart-whats.com
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                لتثبيت الأداة
                            </td>
                            <td>
                                <a class="btn btn-sm btn-primary" href="https://chromewebstore.google.com/detail/dlfcidnplckjjfonobmomikcfamlojbp?utm_source=item-share-cb" target="_blank">
                                    <i class="fa fa-download"></i>
                                    اضغط هنا
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                فيديو توضيحيح للخدمة
                            </td>
                            <td>
                                <a class="btn btn-sm btn-danger" href="https://youtu.be/rfMfpDu15vE" target="_blank">
                                    <i class="fa fa-youtube"></i>
                                    اضغط هنا
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr>
            <div class="form-group">
              <h5 for="">رقم الجوال في الواتس المباشر</h5>
              <input type="text" class="form-control" v-model="xwa_username">
            </div>
            <div class="form-group">
              <h5 for="">كلمة المرور في الواتس المباشر</h5>
              <input type="password" class="form-control" v-model="xwa_password">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="save()">
                    حفظ
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            xwa_username: "",
            xwa_password: "",
        }
    },
    created(){
        this.getInfo()
    },
    methods: {
        getInfo(){
            var g = this;
             $.post(api + '/user/general/settings/xwa', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.xwa_username = r.response.xwa_username
                    g.xwa_password = r.response.xwa_password
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        },
        save(){
            var g = this;
             $.post(api + '/user/general/settings/xwa/save', {
                jwt: this.user.jwt,
                xwa_username: this.xwa_username,
                xwa_password: this.xwa_password,
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    alert("تم الحفظ", 100)
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>

</style>